import { gql } from '@apollo/client';

export const GET_WEIGHING_TASKS = gql`
    query GetWeighingTasks($page: Int, $size: Int) {
        portalWeighingTasks(page: $page, size: $size) {
            content {
                id
                sourceFileName
                sourceFileSize
                status
                totalCount
                successCount
                failedCount
                ignoredCount
                createdAccountNumber
                createdAt
                updatedAt
                completedAt
            }
            totalElements
            totalPages
            page
            size
        }
    }
`;
